export type Appearance = "system" | "light" | "dark";
export type ResolvedAppearance = Exclude<Appearance, "system">;

export function parseAppearance(value: unknown): Appearance {
  return value === "light" || value === "dark" ? value : "system";
}

export function appearanceStorageKey(userId: string) {
  return `oasis:appearance:v1:${userId}`;
}

export function resolveAppearance(
  appearance: Appearance,
  prefersDark: boolean
): ResolvedAppearance {
  if (appearance !== "system") {
    return appearance;
  }
  return prefersDark ? "dark" : "light";
}

export function readAppearance(storage: Pick<Storage, "getItem">, userId: string): Appearance {
  try {
    return parseAppearance(storage.getItem(appearanceStorageKey(userId)));
  } catch {
    return "system";
  }
}
